import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ChevronDoubleLeftIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <polygon points="8.95 17.6 2.19 9.99 9.16 2.4 10.04 3.21 3.81 10.01 9.85 16.8 8.95 17.6"/>
            <polygon points="15.85 17.61 9.09 10.01 16.06 2.41 16.94 3.22 10.71 10.02 16.75 16.81 15.85 17.61"/>
            <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)"/>
        </SvgIcon>
    );
};
